import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '@shared/services/alert.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-google-auth-button',
  templateUrl: './google-auth-button.component.html',
  styleUrls: ['./google-auth-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GoogleAuthButtonComponent implements OnInit {
  @Input() redirectTo: string;
  
  protected loading: boolean;
  protected isAuthenticated: boolean;

  private subscription = new Subscription();
  
  constructor(
    private alertService: AlertService,
    private oidcSecurityService: OidcSecurityService,
    private changeDetector: ChangeDetectorRef,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.subscription.add(
      this.oidcSecurityService
        .checkAuth()
        .subscribe(({ isAuthenticated }) => this.isAuthenticated = isAuthenticated)
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  
  private logoutLocal(): void {
    this.oidcSecurityService.logoffLocal();

    this.loading = false;
    this.isAuthenticated = false;

    this.changeDetector.detectChanges();
  }

  protected login() {
    this.loading = true;

    this.oidcSecurityService.authorizeWithPopUp().subscribe({
      next: ({ isAuthenticated }) => {        
        this.isAuthenticated = isAuthenticated;
        isAuthenticated && this.redirectTo && this.router.navigateByUrl(`/${this.redirectTo}`)
      },
      error: err => {
        this.alertService.danger('google-drive.login-error');
        this.loading = false;
        this.changeDetector.detectChanges();
      },
      complete: () => {
        this.loading = false;
        this.changeDetector.detectChanges();
      }
    });
  }

  protected logout() {
    this.loading = true;    
    
    this.oidcSecurityService.logoffAndRevokeTokens().subscribe({
      next: () => this.logoutLocal(),
      error: () => this.logoutLocal()
    });
  }
}
